import { ModalProvider } from "@client/providers/ModalProvider";
import { TooltipProvider } from "@client/providers/TooltipProvider";

export const Providers = ({ children }: { children: React.ReactNode }) => {
	return (
		<TooltipProvider>
			<ModalProvider>{children}</ModalProvider>
		</TooltipProvider>
	);
};
